import { useEffect } from "react";
import LogRocket from "logrocket";
import { useAuthContext } from "@/context/AuthContext";

if (import.meta.env.VITE_LOGROCKET_PROJECT_PATH) {
  LogRocket.init(import.meta.env.VITE_LOGROCKET_PROJECT_PATH, {
    release: import.meta.env.VITE_GIT_COMMIT || "unknown",
  });
} else {
  console.log("Logrocket not activated on this server");
}

export const LogRocketProvider = () => {
  const { user } = useAuthContext();

  useEffect(() => {
    if (!user.id) {
      LogRocket.identify("", {
        email: user.email,
      });
    }
  }, [user.id, user.email]);

  useEffect(() => {
    if (user.id) {
      if (import.meta.env.VITE_LOGROCKET_PROJECT_PATH) {
        LogRocket.identify(user.id, {
          name: `${user.firstName} ${user.lastName}`,
          email: user.email,
        });
      }
    }
  }, [user.id]);

  return null;
};
